export default "/kiban/_next/static/images/designInstruction-6a15e25a16eeedbddc8f3be1bf5e8530.png";